import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Search, PenTool, Hammer, Rocket } from 'lucide-react';
import { Container, SectionHeading, fadeInUp } from './shared';

const ICONS = [Search, PenTool, Hammer, Rocket];

interface Step {
  title: string;
  description: string;
}

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  const steps = t('landing.howItWorks.steps', { returnObjects: true }) as Step[];

  return (
    <section id="how-it-works" className="relative py-24 sm:py-32">
      <Container>
        <SectionHeading eyebrow={t('landing.howItWorks.eyebrow')} title={t('landing.howItWorks.title')} />

        <div className="relative mt-20 grid gap-6 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-transparent via-white/10 to-transparent lg:block" />
          {steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={step.title}
                variants={fadeInUp}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                className="relative"
              >
                <div className="glass-card h-full rounded-2xl p-7">
                  <div className="mb-6 flex items-center justify-between">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-button shadow-glow">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                    <span className="text-3xl font-bold text-white/10">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mb-2 text-lg font-semibold text-white">{step.title}</h3>
                  <p className="text-sm leading-relaxed text-brand-muted">{step.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;
